import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TableLayout from "../../../components/TableLayout";
import { CstmPagination } from "../../../components/Common/Common";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import dataHandler from "../../../hooks/dataHandler";
import {
  CONTENT_DELETE,
  CONTENT_LIST,
  GET_BASIC_SETTING,
} from "../../../services/ApiCalls";
import CustomPagination from "../../../components/Common/CustomPagination";
import Filter from "../../../components/Common/Filter";
import {
  activeInActiveArr,
  activeInactiveOptions,
} from "../../../utilities/const";
import TableActions from "../../../components/Common/TableActions";
import Toggle from "../../../components/Common/Toggle";
import moment from "moment";

const ContentPage = () => {
  const { t } = useTranslation();
  const {
    setBody,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
    statusChangeHandler,
  } = dataHandler({
    api: CONTENT_LIST,
    extraBody: { language: "English" },
    depenendencyArr: ["language", "deviceType"]
  });

  const [languages, setLanguages] = useState([]);

  const handleLanguageChange = (e) => {
    const value = e.target.value;
    setBody((prev) => ({ ...prev, language: value }));
  };
  const handleDeviceChange = (e) => {
    const value = e.target.value;
    setBody((prev) => ({ ...prev, deviceType: value }));
  };

  const fetchLanguages = async () => {

    try {
      const res = await GET_BASIC_SETTING();

      if (res?.data?.status_code === 200) {
        setLanguages(res?.data?.data?.languageSetting ?? [])
      }

    } catch (err) {

    }

  }
  useEffect(() => {
    fetchLanguages();
  }, [])

  const column = [
    {
      head: t("contentPageManagement.columns.serialNumber"),
      accessor: "srNo",
      component: (item, key) => {
        return <>{body.limit * (body.page - 1) + key + 1}</>;
      },
    },
    { head: t("contentPageManagement.columns.pages"), accessor: "name" },
    { head: t("contentPageManagement.columns.deviceType"), accessor: "deviceType" },
    {
      head: t("contentPageManagement.columns.status"),
      accessor: "",
      isComponent: true,
      component: (item, ind) => (
        <span
          className={`px-2 py-0 rounded ${item?.status === "Active"
            ? "bg-success text-white"
            : "bg-danger text-white"
            }`}
        >
          {item?.status === "Active" ? t("contentPageManagement.status.active") : t("contentPageManagement.status.inactive")}
        </span>
      ),
    },

    {
      head: t("contentPageManagement.columns.createdAt"),
      accessor: "createdAt",
      classNames: "fw-sbold",
      isComponent: true,
      component: (item) => (
        <>{moment(item.date_created_utc).format("MM-DD-YYYY , HH:MM")}</>
      ),
    },
    {
      head: t("contentPageManagement.columns.actions"),
      accessor: "",
      isComponent: true,
      //
      component: (item) => (
        <TableActions
          editUrl={`/content-page/edit/${item._id}`}
        // setDeleteModel={() =>
        //   setDeleteModel({ show: true, dumpId: item._id })
        // }
        />
      ),
    },
  ];

  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel({ show: false, dumpId: "" })}
        confirmHandler={() =>
          deleteHandler(() => CONTENT_DELETE({ _id: deleteModel.dumpId }))
        }
      />
      <section className="contentPage py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                {t("contentPageManagement.title")}
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left d-flex gap-3 ">
                  <div style={{ minWidth: "150px" }}>
                    <Form.Label className="fw-semibold text-muted mb-1">
                      {t("contentPageManagement.labels.filterByLanguages")}
                    </Form.Label>
                    <Form.Select
                      value={body.language || ""}
                      onChange={handleLanguageChange}
                      className="shadow-sm mt-2"
                    >
                      {languages?.length ? languages?.map((opt) => {
                        return <option value={opt.name}>{opt.name}</option>
                      }) : <></>}

                    </Form.Select>
                  </div>
                  <div style={{ minWidth: "150px" }}>
                    <Form.Label className="fw-semibold text-muted mb-1">
                      {t("contentPageManagement.labels.filterByDevice")}
                    </Form.Label>
                    <Form.Select
                      value={body.deviceType || ""}
                      onChange={handleDeviceChange}
                      className="shadow-sm mt-2"
                    >

                      <option value="">{t("contentPageManagement.deviceOptions.all")}</option>
                      <option value="mobile">{t("contentPageManagement.deviceOptions.mobile")}</option>
                      <option value="web">{t("contentPageManagement.deviceOptions.web")}</option>

                    </Form.Select>
                  </div>
                  <Filter
                    body={body}
                    searchHandler={searchHandler}
                    setBody={setBody}
                    statusFilterOptionArr={activeInactiveOptions}
                  />
                </div>
                {/* <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    <li className="">
                      <Link
                        to={"/content-page/add"}
                        className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                      >
                        Add New
                      </Link>
                    </li>
                  </ul>
                </div> */}
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout loader={loader} data={data} column={column} />
              <CustomPagination
                body={body}
                pageChangeHandler={paginationHandler}
                setBody={setBody}
                total={total}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ContentPage;
